export default __webpack_public_path__ + "static/159-min-min-e7c909f983f29643117393faf3d97fef.jpg";